import { maintainStateKey } from '@iwRouter/LocationHelper';
import { useHistory } from 'react-router-dom';

const FUNDING_REQUIREMENTS_ROUTE = '/funding-requirements/';

export const useGoToFundingRequirements = () => {
    const history = useHistory();

    return ({ offerId, amount }: { offerId: string; amount: number }) => {
        const search = new URLSearchParams({
            offerId,
            amount: String(amount)
        }).toString();

        history.push(
            maintainStateKey({
                pathname: FUNDING_REQUIREMENTS_ROUTE,
                search: `?${search}`
            })
        );
    };
};
